
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/special/[sdaCode]",
      function () {
        return require("private-next-pages/store/special/[sdaCode]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/special/[sdaCode]"])
      });
    }
  